export function initializeIntlTelInput() {
    let inputs = document.querySelectorAll("input[type='tel']");

    if (typeof window !== "undefined") {
        if (typeof window.intlTelInput !== "undefined") {
            for (let i = 0; i < inputs.length; i++) {
                let input = inputs[i];
                let iti = window.intlTelInput(input, {
                    preferredCountries: ["CZ", "DE", "GB", "SK", "PL", "FR", "ES", "HU", "IT"],
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.2/js/intlTelInput.min.js"
                });

                let form = input.closest("form");

                form.addEventListener("submit", function(e) {
                    let countryData = iti.getSelectedCountryData();
                    let dialCode = countryData.dialCode;

                    if(typeof(dialCode) !== "undefined" && !input.value.includes("+")) {
                        input.value = "+" + dialCode + input.value;
                    }

                    console.log(input.value);
                });

            }
        }
    }
}